export const ADD_TEAM_RESET = 'ADD_TEAM_RESET';
export const ADD_TEAM_REQUEST = 'ADD_TEAM_REQUEST';
export const ADD_TEAM_REQUEST_COMPLETED = 'ADD_TEAM_REQUEST_COMPLETED';
export const ADD_TEAM_REQUEST_ERROR = 'ADD_TEAM_REQUEST_ERROR';

export const FETCH_TEAM_REQUEST = 'FETCH_TEAM_REQUEST';
export const FETCH_TEAM_REQUEST_COMPLETED = 'FETCH_TEAM_REQUEST_COMPLETED';
export const FETCH_TEAM_REQUEST_ERROR = 'FETCH_TEAM_REQUEST_ERROR';
export const FETCH_TEAM_RESET = 'FETCH_TEAM_RESET';

export const FETCH_TEAM_LIST_REQUEST = 'FETCH_TEAM_LIST_REQUEST';
export const FETCH_TEAM_LIST_REQUEST_COMPLETED = 'FETCH_TEAM_LIST_REQUEST_COMPLETED';
export const FETCH_TEAM_LIST_REQUEST_ERROR = 'FETCH_TEAM_LIST_REQUEST_ERROR';

export const FETCH_SWITCH_TEAM_LIST_REQUEST = 'FETCH_SWITCH_TEAM_LIST_REQUEST';
export const FETCH_SWITCH_TEAM_LIST_REQUEST_COMPLETED = 'FETCH_SWITCH_TEAM_LIST_REQUEST_COMPLETED';
export const FETCH_SWITCH_TEAM_LIST_REQUEST_ERROR = 'FETCH_SWITCH_TEAM_LIST_REQUEST_ERROR';
export const FETCH_SWITCH_TEAM_LIST_REQUEST_RESET='FETCH_SWITCH_TEAM_LIST_REQUEST_RESET'

export const FETCH_TEAM_USER_LIST_REQUEST = 'FETCH_TEAM_USER_LIST_REQUEST';
export const FETCH_TEAM_USER_LIST_REQUEST_COMPLETED = 'FETCH_TEAM_USER_LIST_REQUEST_COMPLETED';
export const FETCH_TEAM_USER_LIST_REQUEST_ERROR = 'FETCH_TEAM_USER_LIST_REQUEST_ERROR';



// WEBPACK FOOTER //
// ./constants/teamdetails.js